export const SECTION_IDS = [
  'overview',
  'people',
  'ghg',
  'buildings',
  'transportation',
  'policy-tool',
  'community',
  'other',
  'admin-settings',
  'coolclimate-calculator',
  'analysis',
] as const;

export type SectionId = (typeof SECTION_IDS)[number];

export const ALL_SECTIONS_SET = new Set<string>(SECTION_IDS);

/** Sections visible in the navigation bar (excludes community, admin-settings). */
export const NAV_VISIBLE_SECTIONS = new Set<string>([
  'overview',
  'transportation',
  'buildings',
  'other',
  'people',
  'ghg',
  'policy-tool',
  'coolclimate-calculator',
  'analysis',
  'law-impact',
]);
